export const AdBottomLeaderboard = () => {
    return <div data-aaad="true" data-aa-adunit="/275516369/ImageResizer_BottomLeaderboard"></div>;
};
